module.exports = __webpack_public_path__ + "static/media/sport-ski.d1d224b4.mp4";